
import Cell from 'vux/src/components/cell/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import value2name from 'vux/src/filters/value2name.js'
import XAddress from 'vux/src/components/x-address/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
components: {
Checker,
CheckerItem,
CheckIcon,
Group,
XInput,
XHeader,
XButton,
Cell,
XAddress,
Selector
},
data() {
return {
issue: false,
invoiceType: 1,
invoiceTitle: 2,
invoice: {
company: "",
taxNumber: "",
bank: "",
bankAccount: "",
address: "",
tel: ""
},
type: "",
name: "",
idcard: "",
mobile: "",
ename: "",
emobile: "",
etelephone: "",
email: '',
address1: [],
address2: "",
zipcode: "",

addressData: ChinaAddressV4Data,
eduList: [{key: "是", value: "是"}, {key: "否", value: "否"}],
company: ''
};
},
methods: {
save() {
if (!this.company) {
this.$vux.alert.show({
title: "",
content: "请填写工作单位"
});
return
}
if (this.ename != "" && this.emobile != "") {
var invoiceAll = {};
if (this.issue) {
if (this.invoiceType == 1) {
this.invoice.bank = "";
this.invoice.bankAccount = "";
this.invoice.address = "";
this.invoice.tel = "";
this.type = "ValueAddedTaxInvoiceUnit"; 
if (this.invoiceTitle == 1) {
this.invoice.company = "";
this.invoice.taxNumber = "";
this.type = "ValueAddedTaxInvoiceOne"; 
}
} else {
this.type = "VatSpecialInvoice"; 
}
invoiceAll = {
"content": this.invoice,
"type": this.type
};
} else {
invoiceAll = {
"content": null,
"type": ''
};
}
if (this.address1.length !== 3 || !this.address2) {
alert('请填写通讯地址')
return
}
let address = value2name(this.address1, ChinaAddressV4Data);
address = address.split(' ')
var obj = {

name: this.name,
idcard: this.idcard,
mobile: this.mobile,
ename: this.ename,
emobile: this.emobile,
etelephone: this.etelephone,
province: address[0],
city: address[1],
district: address[2],
daddress: this.address2,
zipcode: this.zipcode,
email: this.email,
invoice: invoiceAll,
company: this.company,
sequence: 0
};
var opid = localStorage.getItem("userid");
var head = {
headers: {
token: localStorage.getItem("token"),
opid: opid
}
};
let that = this;
this.$http.post("/api/v1/users/" + opid, obj, head)
.then(function (res) {
that.$router.push({name: "vip"});
})
.catch(function (error) {
that.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: "cancel",
time: "1000"
});
});
} else {
this.$vux.alert.show({
title: "",
content: "输入信息不完整，请补全后再提交"
});
}
},
},
created() {
let opid = localStorage.getItem("userid");
let obj = {
headers: {
token: localStorage.getItem("token"),
opid: opid
}
};
this.$http.get("/api/v1/experts/" + opid, obj)
.then((res) => {
this.name = res.data.detail.name;
this.idcard = res.data.detail.idcard;
this.mobile = res.data.detail.mobile;
this.ename = res.data.detail.ename;
this.emobile = res.data.detail.emobile;
this.email = res.data.detail.email
this.company = res.data.detail.company
this.address1 = [res.data.detail.province, res.data.detail.city, res.data.detail.district]
this.address2 = res.data.detail.daddress
})
.catch(function (err) {
console.log(err);
});
}
};



// WEBPACK FOOTER //
// ./src/components/addmyInfo.vue